import React from 'react';
import { Star } from 'lucide-react';
import { ThemedText } from '../../../components';

export default function RatingValue({ value, field, emptyValue = '—', theme }) {
  if (value == null || value === '') {
    return <ThemedText style={{ color: theme?.colors?.muted }}>{emptyValue}</ThemedText>;
  }

  const numValue = Number(value);
  const maxRating = field?.props?.maxRating || field?.props?.configuration?.maxRating || 5;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      {Array.from({ length: maxRating }, (_, i) => (
        <Star
          key={i}
          size={16}
          fill={i < numValue ? (theme?.colors?.warning || '#f59e0b') : 'none'}
          color={i < numValue ? (theme?.colors?.warning || '#f59e0b') : (theme?.colors?.muted || '#9ca3af')}
        />
      ))}
      <ThemedText style={{ marginLeft: 4 }}>{numValue}/{maxRating}</ThemedText>
    </div>
  );
}
